// ============================================
// GWP Cart Script — Haarspullen.nl
// ============================================

if (window.Shopify && window.Shopify.market && window.Shopify.market.handle !== 'nl') {
  throw new Error('GWP: niet-NL markt, script gestopt.');
}

var GWP_CAMPAIGNS = [
  { active: false, tag: 'gwp-wella-eimi', giftVariantId: '56328020296054', giftHandle: 'wella-fusion-shampoo' },
  { active: false, tag: 'gwp-kms', giftVariantId: '57720099766646', giftHandle: 'therma-shape-quick-blow-dry-75ml' },
    { active: true,  tag: 'gwp-indola-hairpin',     giftVariantId: '57676128715126', giftHandle: 'indola-hairpin' },
  { active: true,  tag: 'gwp-ghd-toolbag',        giftVariantId: '56519708279158', giftHandle: 'ghd-tool-bag' },
  { active: true,  tag: 'gwp-blondme-set',        giftVariantId: '57794776072566', giftHandle: 'schwarzkopf-comb-mirror-set' },
  { active: true,  tag: 'gwp-maniac-topcoat',     giftVariantId: '56590815363446', giftHandle: 'maniac-top-coat-shine' },
  { active: true,  tag: 'gwp-gladskin-lipbalm',   giftVariantId: '57794984542582', giftHandle: 'everyday-lip-balm-spf30' },
  { active: true,  tag: 'gwp-fibreclinix-curls',  giftVariantId: '57795020554614', giftHandle: 'schwarzkopf-heatless-curling-set' },
  { active: true,  tag: 'gwp-sebastian-kaars',    giftVariantId: '57798933315958', giftHandle: 'sebastian-dark-oil-geurkaars' },
{ active: true, tag: 'gwp-mediceuticals-comb', giftVariantId: '57728046268790', giftHandle: 'mediceuticals-scalpro-brush-buddy-comb-cleanser' },

];

// ============================================
// Logica — niet aanpassen
// ============================================

var gwpRunning = false;
var gwpFetching = false;

function gwpGetCart() {
  return fetch('/cart.js').then(function(r) { return r.json(); });
}

function gwpAddToCart(variantId) {
  gwpFetching = true;
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1, properties: { _gwp: 'true' } }),
  }).finally(function() { gwpFetching = false; });
}

function gwpRemoveFromCart(variantId) {
  gwpFetching = true;
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 0 }),
  }).finally(function() { gwpFetching = false; });
}

async function gwpIsGiftAvailable(handle, variantId) {
  try {
    var res = await fetch('/products/' + handle + '.js');
    var product = await res.json();
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === String(variantId)) {
        return product.variants[i].available;
      }
    }
    return false;
  } catch(e) {
    return false;
  }
}

async function updateGWP() {
  if (gwpRunning) return;
  gwpRunning = true;

  try {
    var cart = await gwpGetCart();

    for (var i = 0; i < GWP_CAMPAIGNS.length; i++) {
      var campaign = GWP_CAMPAIGNS[i];
      if (!campaign.active) continue;

      var giftAvailable = await gwpIsGiftAvailable(campaign.giftHandle, campaign.giftVariantId);

      var taggedCount = 0;
      var giftInCart = null;

      for (var j = 0; j < cart.items.length; j++) {
        var item = cart.items[j];
        if (String(item.variant_id) === String(campaign.giftVariantId)) continue;
        try {
          var res = await fetch('/products/' + item.handle + '.js');
          var product = await res.json();
          if (product.tags.includes(campaign.tag)) taggedCount++;
        } catch(e) {}
      }

      for (var k = 0; k < cart.items.length; k++) {
        var cartItem = cart.items[k];
        if (String(cartItem.variant_id) === String(campaign.giftVariantId) && cartItem.properties && cartItem.properties._gwp === 'true') {
          giftInCart = cartItem;
        }
      }

      var currentGiftQty = giftInCart ? giftInCart.quantity : 0;

      if (!giftAvailable) {
        if (currentGiftQty > 0) {
          await gwpRemoveFromCart(campaign.giftVariantId);
          location.reload();
          return;
        }
        continue;
      }

      if (taggedCount > 0 && currentGiftQty === 0) {
        await gwpAddToCart(campaign.giftVariantId);
        location.reload();
        return;
      } else if (taggedCount === 0 && currentGiftQty > 0) {
        await gwpRemoveFromCart(campaign.giftVariantId);
        location.reload();
        return;
      }
    }
  } catch(e) {}

  gwpRunning = false;
}

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(updateGWP, 800);
});

document.addEventListener('cart:updated', function() { gwpRunning = false; updateGWP(); });
document.addEventListener('cart:refresh', function() { gwpRunning = false; updateGWP(); });

// Fetch interceptor — pikt cart wijzigingen direct op
var _fetch = window.fetch;
window.fetch = function() {
  var args = arguments;
  return _fetch.apply(this, args).then(function(res) {
    if (gwpFetching) return res;
    var url = typeof args[0] === 'string' ? args[0] : '';
    if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear')) {
      setTimeout(function() { gwpRunning = false; updateGWP(); }, 300);
    }
    return res;
  });
};

// Productpagina badge voorraad check
(function() {
  GWP_CAMPAIGNS.forEach(function(campaign) {
    if (!campaign.active || !campaign.giftHandle) return;
    var selector = '.overlay-gwp-' + campaign.tag.replace('gwp-', '');
    var el = document.querySelector(selector);
    if (!el) return;
    fetch('/products/' + campaign.giftHandle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(p) {
        var available = p.variants.some(function(v) {
          return String(v.id) === String(campaign.giftVariantId) && v.available;
        });
        if (!available) el.style.display = 'none';
      });
  });
})();
